import { NavSectionProps } from '~/components/NavSection';
import { IntlShape } from 'react-intl';

const navSectionService = (
  data: { teasers: [] },
  intl: IntlShape,
): NavSectionProps => {
  return {
    items: data.teasers?.map(
      (teaser: { anchorTag: string; inpageNavigationTitle: string }) => ({
        id: teaser.anchorTag,
        meta: teaser.inpageNavigationTitle,
      }),
    ),
    displayTitle: true,
    customScrollHandling: true,
    sectionHeaderTitle: intl.formatMessage({
      id: `nav.section.header.title`,
    }),
  };
};

export default navSectionService;
